<template>
  <div class="jewelryEncyc">
    <div class="jewelryEncyc-image">
      <img src="@/assets/img/jewelryEncycTopImg.svg" alt="" width="100%">
      <p style="font-size: 80px;
                font-weight: 900;
                letter-spacing: 0px;
                line-height: 0px;
                color: rgba(255, 255, 255, 1);
                text-align: center;
                vertical-align: top;">
                Here you come
        </p>
    </div>
    <div class="jewelryEncyc-content center-wrapper">
      <div class="jewelryEncyc-left">
        <p>珠宝分类</p>
        <el-menu
          :default-openeds='[jewelryEncycType]'
          :default-active='defaultActive'
          unique-opened
          @open="open"
          @select="select"
          class="el-menu-vertical-demo">
          <el-submenu :index="`${item.id}`" v-for="(item, index) of leftList" :key="index">
            <template slot="title">
              <span>{{item.title}}</span>
            </template>
            <template  v-if="item.list">
            <el-menu-item-group v-for="(items) of item.list" :key="`${item.id}-${items.id}`">
              <el-menu-item :index="`${item.id}-${items.id}`">{{items.title}}</el-menu-item>
            </el-menu-item-group>
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <div class="jewelryEncyc-right"  v-html="details && details.content">
        <div class="jewelryEncyc-right-topXzl">
          <img src="@/assets/img/jewelryEncycZs.png" alt="" width="29%">
          <div class="jewelryEncyc-right-topXzl-content">
            <h1 class="topXzl-title">钻石<span style="font-size: 16px;color: rgb(48,48,48);margin-left: 10px;font-weight: 500;">Diamond</span></h1>
            <fgx />
            <div class="topXzl-xiangxi">
              <div class="topXzl-xiangxi-left">
                化学成分：C<br>
                硬度：10<br>
                比重：3.52<br>
                折射率：2.42<br>
              </div>
              <div class="topXzl-xiangxi-right">
                佩戴注意：避免撞击，避免撞击，避免撞击，避免撞击，避免撞击，避免撞击
              </div>
            </div>
          </div>
        </div>
        <ul class="jewelryEncyc-right-imageList">
          <li class="jewelryEncyc-right-imageList-item" v-for="(item, index) of rightImageList" :key='index+"list"'>
            <img src="@/assets/img/jewelryEncycImagListItem-1.png" alt="" width="100%">
            <!-- 注释掉悬浮 -->
            <!-- <div class='imageList-item-hover'>
              名称/颜色
            </div> -->
          </li>
          <li class="jewelryEncyc-right-imageList-item" v-for="item of 6 - rightImageList.length % 6" :key="item"></li>
        </ul>
        <fgx style="margin: 40px 0;position: relative;padding: 0" title='简介'/>
        <ul class="jewelryEncyc-right-jianjie">
          <li v-for="(item, index) of jianjieList" :key="index" class="jewelryEncyc-right-jianjie-item">
            <h1 class="right-jianjie-title" v-if="item.title">
              {{item.title}}
            </h1>
            <div v-html="item.content">
            </div>
            <ul v-if="item.imgList" class="right-jianjie-img">
              <li v-for="(items, index) of item.imgList" :key="index+'jianjieimg'" class="right-jianjie-img-item">
                <img :src="items" alt="" width="100%">
              </li>
              <li class="right-jianjie-img-item" v-for="item of 3 - item.imgList.length % 3" :key="item"></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import fgx from '@/components/fgx/index'
import { fetchBaikeDetails } from '@/api/api';
export default {
  components: {
    fgx
  },
  watch: {
    '$route'() {
      this.jewelryEncycType = this.$route.query.jewelryEncycType
    },
    leftList () {
      this.defaultActive = `${this.jewelryEncycType}-${this.leftList && this.leftList.filter(item => item.id == this.jewelryEncycType)[0].list[0].id}`
      this.select(this.defaultActive)
    }
  },
  data () {
    return {
      details: null,
      defaultActive: '',
      jewelryEncycType: '0',
      jianjieList: [
        {
          content: `<div>
          <span>钻石</span>
          （ Diamond ）是一种 r 元素矿物 J ( Elemental mineral ) ，纯净的钻石完全由碳元素（ C ）构成，素矿物。环境中，「钻石 J 形成于地球内部 130 一 ZOOkm 深的地慢（ Mant ! e ）层，温度必须达到 900 " C 至 1300 " C , 是唯一可以用作宝石的单一元压强达到 4 . 5 万至 6 万大气压的黑色碳才会转换为透明的晶体状态，亦即「钻石」。
          </div>
          <div style='margin: 25px 0'>在火山爆发等地壳活动中，地慢层中包含「钻石」的岩石有可能因地壳运动而粉碎，被爆发的岩浆喷出地表并瞬间冷却，于是就完整保留在地表层上。</div>
          <p>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>`,
          imgList: [
            require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
            require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
          ]
        },
        {
          title: '人类对钻石的认知',
          content: `<div style='margin: 25px 0'>
          <span>钻石</span>
          （ Diamond ）是一种 r 元素矿物 J ( Elemental mineral ) ，纯净的钻石完全由碳元素（ C ）构成，素矿物。环境中，「钻石 J 形成于地球内部 130 一 ZOOkm 深的地慢（ Mant ! e ）层，温度必须达到 900 " C 至 1300 " C , 是唯一可以用作宝石的单一元压强达到 4 . 5 万至 6 万大气压的黑色碳才会转换为透明的晶体状态，亦即「钻石」。
          </div>
          <div style='margin-bottom: 25px'>在火山爆发等地壳活动中，地慢层中包含「钻石」的岩石有可能因地壳运动而粉碎，被爆发的岩浆喷出地表并瞬间冷却，于是就完整保留在地表层上。</div>`
        },{
          title: '开采历史',
          content: `<div style='margin: 25px 0'>
          <span>钻石</span>
          （ Diamond ）是一种 r 元素矿物 J ( Elemental mineral ) ，纯净的钻石完全由碳元素（ C ）构成，素矿物。环境中，「钻石 J 形成于地球内部 130 一 ZOOkm 深的地慢（ Mant ! e ）层，温度必须达到 900 " C 至 1300 " C , 是唯一可以用作宝石的单一元压强达到 4 . 5 万至 6 万大气压的黑色碳才会转换为透明的晶体状态，亦即「钻石」。
          </div>
          <div style='margin-bottom: 25px'>在火山爆发等地壳活动中，地慢层中包含「钻石」的岩石有可能因地壳运动而粉碎，被爆发的岩浆喷出地表并瞬间冷却，于是就完整保留在地表层上。</div>`
        },{
          title: '钻石颜色',
          content: `<p style='margin: 25px 0'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>`,
          imgList: [
            require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
            require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
            require('@/assets/img/jewelryEncycJianjieImagListItem-1.png')
          ]
        },{
          title: '钻石保养',
          content: `<p style='margin-top: 25px'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>
          <p style='margin-top: 25px'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>
          <p style='margin: 25px 0'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>`
        },{
          title: '钻石的评级因素',
          content: `<p style='margin: 25px 0'>钻石的评级因素钻石的评级依据四个主要因素，亦即常说的 r4CJ。</p>
          <p>Carat （克拉重量）：宝石的重量。</p>
          <p>Cofor （颜色）：颜色的等级，相对的洁白度，或彩色的稀有性和美观性。</p>
          <p>Clarity （净度）：包裹体和裂隙的程度。</p>
          <p>Cut （切工）：切磨的啄型和品质。</p>`
        },
      ],
      rightImageList: [
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
        '@/assets/img/jewelryEncycImagListItem-1.png',
      ]
    }
  },
  computed: {
    leftList: function(){
      return this.$store.state.jewelryEncycData.data ? this.$store.state.jewelryEncycData.data.left_list : []
    }
  },
  mounted () {
    this.jewelryEncycType = this.$route.query.jewelryEncycType
    if (this.leftList.filter(item => item.id == this.jewelryEncycType)) {
      this.defaultActive = `${this.jewelryEncycType}-${this.leftList && this.leftList.filter(item => item.id == this.jewelryEncycType)[0].list[0].id}`
      this.select(this.defaultActive)
    }
  },
  methods: {
    select (e) {
      console.log(e)
      fetchBaikeDetails({
        id: e.split('-')[1],
        category_id: e.split('-')[0]
      }).then(r => {
        this.details = r.data.data.details
      })
    },
    open(key, keyPath) {
      this.$router.replace(`/jewelryEncyc?jewelryEncycType=${key}&inoScrollTop=1`)
    }
  }
}
</script>
<style>
.jewelryEncyc-right-imageList-item:hover .imageList-item-hover{
  opacity: 1 !important;
}
</style>
<style lang='scss'>
.jewelryEncyc {
  .jewelryEncyc-image {
    position: relative;
    >p {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .jewelryEncyc-content {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    .jewelryEncyc-left {
      width: 15%;
      max-width: 200px;
      p{
        padding: 10px;
        color: rgb(127,126,126);
        text-align: center;
      }
    }
    .jewelryEncyc-right {
      width: 80%;
      .jewelryEncyc-right-topXzl {
        display: flex;
        justify-content: space-between;
      }
      .jewelryEncyc-right-topXzl-content {
        margin-top: 10px;
        width: 69%;
      }
      .topXzl-title {
        font-size: 24px;
        font-weight: 600;
        display: flex;
        align-items: flex-end;
      }
      .topXzl-xiangxi {
        display: flex;
        justify-content: space-between;
        >div {
          font-size: 20px;
          width: 49%;
          line-height: 34px;
        }
      }
      .topXzl-fgx {
        border-bottom: 1px dashed rgb(222,222,222);
        padding: 8px;
        margin-bottom: 20px;
        .topXzl-fgx-title {
          left: 0;
          top: 0;
          font-size: 12px;
          padding: 5px 10px;
          position: absolute;
          border-radius: 3px;
          transform: translateY(-50%);
          background: rgb(227,227,227);
        }
      }
      .jewelryEncyc-right-imageList {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .jewelryEncyc-right-imageList-item {
          position: relative;
          margin-top: 20px;
          width: 15%;
          border-radius: 10px;
          .imageList-item-hover {
            font-size: 22px;
            line-height: 35px;
            text-align: center;
            color: #fff;
            opacity: 0;
            width: 100%;
            position: absolute;
            height: 35px;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            border-radius:0 0 10px 10px;
            transition: all 0.3s;
          }
        }
      }
      .jewelryEncyc-right-jianjie {
        line-height: 25px;
        .right-jianjie-title {
          font-weight: 600;
          font-size: 20px;
        }
        .right-jianjie-img{
          margin: 10px 0;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .right-jianjie-img-item{
            width: 30%;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .el-submenu__title {
    font-weight: 600;
    background: rgb(228,228,228);
    font-size: 18px;
    text-align: center;
  }
    .el-submenu {
      &:not(:last-child) {
        border-bottom: 1px solid #fff;
      }
    }
  .el-menu-item-group__title {
    padding: 0
  }
  .el-submenu__icon-arrow {
    right: auto;
    font-size: 16px;
  }
  .el-submenu .el-menu-item {
    min-width: auto;
    text-align: center;
  }
  .el-submenu .is-active {
    color: #fff;
    background: rgb(32,147,202);
  }
  padding-bottom: 30px;
}
</style>